// Note: borrowed some stuff from here: http://stackoverflow.com/questions/28127507/incrementing-value-continuously-on-mouse-hold
// Discovered $$rAF in angular source.  It is definitely a polyfill for requestAnimationFrame.
(function () {
    'use script';

    angular
        .module(app.modules.common.name)
	    .directive('xxRepeatclick', xxRepeatclick);

    xxRepeatclick.$inject = ['$parse', '$$rAF', '$document'];
    function xxRepeatclick($parse, $$rAF, $document) {
        return {
            restrict: 'A',
            link: postLink
        };

        function postLink(scope, element, attr) {
            // Variables
            var isDown = false, isHolding = false, isCanceled = false,
                initialDelay = 300, delay = 75, nextTime = null,
                requestAnimationFrame = $$rAF,
                listener = $parse(attr.xxRepeatclick, null, true);

            // Mouse Events
            element.on('mousedown touchstart', mousedown);
            element.on('mouseup touchend touchcancel', mouseup);
            element.on('mouseleave', mouseup);
            $document.on('touchmove', touchmove); // <== mouse leave for mobile

            // Keyboard Events
            element.on('keypress', keypress);
            element.on('keyup', keyup);

            // Other Events
            element.on('click', click);
            element.on('repeatclick', repeatclick); // <== not a "real" event
            element.on('$destroy', destroy);

            /////////////////////////////////////////////////

            // Mouse Events
            function mousedown(e) {
                if (!isDown) {
                    initializeState();
                    requestAnimationFrame(watcher);
                }
            }

            function mouseup(e) {
                isDown = false;
            }

            function touchmove(e) {
                if (isDown) {
                    var touch = e.touches[0];
                    if (element !== $document[0].elementFromPoint(touch.pageX, touch.pageY))
                        element.triggerHandler('touchcancel');
                }
            }

            // Keyboard Events
            function keypress(e) {
                if (e.which == 13 && !isCanceled) {
                    if (!isDown) 
                        initializeState();
                    else {
                        e.preventDefault();
                        if (!isHolding) {
                            isHolding = true;
                            requestAnimationFrame(watcher);
                        }
                    }
                }
            }

            function keyup(e) {
                if (e.which == 13) {
                    isDown = false;
                    isCanceled = false;
                }
            }

            // Other Events
            function click(e) {
                if (!isHolding)
                    triggerEvent();
            }


            function repeatclick(event) {
                scope.$apply(callback);

                function callback() {
                    listener(scope, { $event: event });
                }
            }

            function destroy() {
                $document.off('touchmove', touchmove)
            }

            // Helpers
            function watcher(time) {
                if (element.prop('disabled'))
                    isDown = false;
                else if (isDown) {
                    requestAnimationFrame(watcher);
                    if (nextTime === null)
                        nextTime = time + initialDelay;
                    else if (time >= nextTime) {
                        nextTime = time + delay;
                        triggerEvent();
                        isHolding = true;
                    }
                }
            }

            function triggerEvent() {
                element.triggerHandler({ type: 'repeatclick', preventDefault: preventDefault });

                function preventDefault() {
                    this.defaultPrevented = true;
                    isDown = false;
                    isCanceled = true;
                }
            }

            function initializeState() {
                isDown = true;
                isHolding = false;
                nextTime = null;
                isCanceled = false;
            }
        }
    }
})();